import { Button, SxProps, Theme } from '@mui/material';

export interface ButtonProps {
  text: string;
  handleOnClick?: () => void;
  color?:
    | 'inherit'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'error'
    | 'info'
    | 'warning';
  endIcon?: JSX.Element;
  sx?: SxProps<Theme>;
  size?: 'small' | 'large' | 'medium';
  className?: string;
  fullWidth?: boolean;
  disabled?: boolean;
  visable?: boolean;
}

export const CustomButton = ({
  text,
  handleOnClick,
  color,
  endIcon,
  sx = [],
  size = 'large',
  className,
  fullWidth = false,
  disabled = false,
  visable = true,
}: ButtonProps) => {
  if (!visable) {
    return null;
  }
  return (
    <Button
      sx={[
        {
          boxShadow: 0,
          border: 0,
          minWidth: 100,
          borderRadius: 0,
          textTransform: 'uppercase',
          fontFamily: 'JHFontBold,arial,sans-serif',
          justifyContent: 'space-between',
          size: 'large',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      className={className}
      endIcon={endIcon}
      disabled={disabled}
      color={color}
      size={size}
      variant="contained"
      onClick={handleOnClick}
      fullWidth={fullWidth}
    >
      {text}
    </Button>
  );
};

CustomButton.defaultProps = {
  handleOnClick: null,
  color: 'primary',
  endIcon: null,
  sx: [],
  size: 'large',
  className: '',
  fullWidth: false,
  disabled: false,
  visable: true,
};
